import { Swatch } from '@cibo/ui'
import { Stack, StackProps, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const EnrollmentListLegend = (stackProps: StackProps) => {
  const {
    palette: { error, success, warning },
  } = useTheme()
  const { t } = useTranslation('impact/components/EnrollmentListLegend')
  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2} {...stackProps}>
      <Stack alignItems="center" direction="row" spacing={1}>
        <Swatch color={success.main} />
        <Typography variant="caption">{t('success')}</Typography>
      </Stack>
      <Stack alignItems="center" direction="row" spacing={1}>
        <Swatch color={warning.main} />
        <Typography variant="caption">{t('warning')}</Typography>
      </Stack>
      <Stack alignItems="center" direction="row" spacing={1}>
        <Swatch color={error.main} />
        <Typography variant="caption">{t('error')}</Typography>
      </Stack>
    </Stack>
  )
}
